(function() {
  // Handle account button clicks to open login popover (both desktop and mobile)
  window.FoxTheme?.DOMready(() => {
    const loginPopover = document.getElementById('LoginPopover');
    const accountButtons = document.querySelectorAll('.account-button[aria-controls="LoginPopover"]');
    
    if (loginPopover && accountButtons.length > 0) {
      accountButtons.forEach((accountButton) => {
        if (!accountButton.dataset.listenerAdded) {
          accountButton.dataset.listenerAdded = 'true';
          accountButton.addEventListener('click', (e) => {
            e.preventDefault();
            loginPopover.setAttribute('open', '');
          });
        }
      });
    }
  });
})();

